import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdventureProgram } from '../models/adventure-program.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdventureProgramService {
  private apiUrl = `${environment.SERVICES.LESSON}adventure-programs`;

  constructor(private http: HttpClient) {}

  listPrograms(): Observable<AdventureProgram[]> {
    return this.http.get<AdventureProgram[]>(this.apiUrl);
  }

  createProgram(program: Partial<AdventureProgram>): Observable<{ programId: string }> {
    return this.http.post<{ programId: string }>(this.apiUrl, program);
  }

  updateProgram(id: string, program: Partial<AdventureProgram>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, program);
  }

  deleteProgram(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
